import Joi from "joi";
import { useDictionary } from "../../contexts/dictionary";
import { BoxContainer, Col, HeroBanner, List, ListItem, Row, TabButtons, TabButtonsItem, Text, Title, VerticalSeparator, VImage } from "../../style/base.style";
import { Colors } from "../../style/colors";



import { Link, useNavigate } from "react-router-dom";
import { useDeviceType } from "../../contexts/DeviceContext";
import { FieldType, TextFieldType } from "../../components/fields";
import { VerticalSepWithTitle } from "../../components/common/verticalSepWithTitle";
import { FormComponent } from "../../components/form";
import { ActionButton } from "../../components/buttons/ActionButton";
import { useFormHandling } from "../../hooks/formUtils";
import { EmailPasswordAuthNew, OtpAuth, PhoneAuthNew } from "../../hooks/socialAuth";
import { useEffect, useState } from "react";
import { RequestConfigs } from "../../api";
import { SocialAuthComponent } from "../../components/socialAuth";
import { TextLink } from "../common/TextLink";
import { useContactType } from "../../contexts/ContactContext";
import { routesMap } from "../../constants/routes";

interface RegistrationProps {
  currentForm?: "registration" | "login"
  nextPage?: string
}


export const RegistrationComponent = ({ currentForm, nextPage }: RegistrationProps) => {

  const [form, setForm] = useState<"registration" | "login">(currentForm || "registration")
  const { translate } = useDictionary()
  const { isMobile } = useDeviceType()
  const { getAuthNextPage, setAuthNextPage } = useContactType()
  const navigate = useNavigate();



  const registerFields: FieldConfig[] = [
    {
      type: FieldType.text,
      name: "Full_Name",
      label: translate("name"),
      joiSchema: Joi.string().pattern(/^\s*\S+\s+\S+\s*$/).message('Must contain exactly two words').required(),
      typeOptions: {
        type: TextFieldType.text,
      }
    },
    {
      type: FieldType.text,
      name: "Phone",
      label: translate("phone_label"),
      joiSchema: Joi.string().required(),
      typeOptions: {
        type: TextFieldType.text,
      }
    },
    {
      type: FieldType.text,
      name: "Email",
      label: translate("email_label"),
      joiSchema: Joi.string().email({ tlds: { allow: false } }).required(),
      typeOptions: {
        type: TextFieldType.text,
      }
    },

    {
      type: FieldType.text,
      name: "password",
      label: translate("password_label"),
      joiSchema: Joi.string().required(),
      typeOptions: {
        type: TextFieldType.password,
      }
    },
  ]


  const passwordLoginFields: FieldConfig[] = [

    {
      type: FieldType.text,
      name: "Email",
      label: translate("email_label"),
      joiSchema: Joi.string().email({ tlds: { allow: false } }).required(),
      typeOptions: {
        type: TextFieldType.text,
      }
    },

    {
      type: FieldType.text,
      name: "password",
      label: translate("password_label"),
      joiSchema: Joi.string().required(),
      typeOptions: {
        type: TextFieldType.password,
      }
    },
  ]

  const otpLoginFields: FieldConfig[] = [

    {
      type: FieldType.text,
      name: "emailOrPhone",
      label: translate("phone_label"),
      joiSchema: Joi.string().required(),
      typeOptions: {
        type: TextFieldType.text,
      }
    },

  ]



  const [combineServerRes, setCombineServerRes] = useState<ApiResponse | null>(null);

  const [formData, setFormData] = useState<any | null>(null)

  const { handleInputChange, handleClick, serverRes, formValues } = useFormHandling({ requestType: RequestConfigs.socialAuth, data: formData })

  useEffect(() => {
    if (formData) {
      handleClick()
    }

  }, [formData])




  const { registerUser, loginUserWithPassword } = EmailPasswordAuthNew()
  const {addPhoneAuth} = PhoneAuthNew()
  
  const [activeTab, setActiveTab] = useState("1");

  const processReg = async () => {
    const regRes = await registerUser(formValues.Email, formValues.password)
    setCombineServerRes(regRes as ApiResponse)
    setFormData(regRes.data)
  }

  const processLogin = async () => {
    const loginRes = await loginUserWithPassword(formValues.Email, formValues.password)
    console.log("login res", loginRes)  
    setCombineServerRes(loginRes as ApiResponse)
    setFormData(loginRes.data)
  }



  const processOTPLogin = async (phone:string) => {
    console.log("process phone auth",phone)
    const phoneRes = await addPhoneAuth(phone)
    if(!phoneRes.succeeded){
      setCombineServerRes(phoneRes as ApiResponse)
    } else {
      navigate( routesMap.otpLogin.to+'?verificationId='+phoneRes.verificationId)
    }
  }


  const processPhoneAuth = async (phone:string) => {
    console.log("process phone auth",phone)
    const phoneRes = await addPhoneAuth(phone)
    if(!phoneRes.succeeded){
      setCombineServerRes(phoneRes as ApiResponse)
    } else {
      navigate( routesMap.otpRegister.to+'?verificationId='+phoneRes.verificationId)
    }
  }


  useEffect(() => {
    let nextpage = null;
    setCombineServerRes(serverRes)
    console.log("setCombineServerRes", serverRes)
    if (serverRes !== null) {
      nextpage = getAuthNextPage()
    }
    if (!serverRes?.succeeded) {
      setCombineServerRes(serverRes)
    } else if (serverRes.succeeded) {
      console.log("check success",serverRes?.contact?.Phone,process.env.REACT_APP_PHONE_AUTH,formValues.Phone)
      if (serverRes?.contact?.Phone) { // phone is already registered
        if(formValues.Phone && process.env.REACT_APP_PHONE_AUTH === 'yes'){ //phone registered now
         processPhoneAuth(formValues.Phone) //start phone auth
         return
        } else {
          console.log("need to be navigate")
          navigate(nextpage || '/dashboard') //auth finished
        }
      } else {
        if (nextpage) {
          setAuthNextPage(nextpage) //bring back next auth
        }
        navigate('/register-phone')
      }
    }
  }
    , [serverRes])



  if (form === "registration")
    return (


      <Col $justifyContent="flex-start" style={{ maxWidth: '500px' }} $width={isMobile ? "100%" : "60%"} $border={`1px solid${Colors.fieldBorder}`} $borderRadius={10} $backgroundColor={Colors.whiteBackground} $gap={10} $padding="20px">
        <FormComponent
          fields={registerFields}
          title={translate("register")}
          onChange={handleInputChange}
          serverRes={combineServerRes}
        />
        <ActionButton width="100%" onClick={() => { processReg() }} label={translate('register')} />

        <VerticalSepWithTitle title={translate('or')} />
        <SocialAuthComponent setFormValues={setFormData} />
        <div className="contact-signup">
          <p>
            {translate('already_have_account')}{" "}
            <TextLink onClick={() => { setForm("login") }}>{translate('login')}</TextLink>

          </p>
        </div>

      </Col>

    )

  return (
    <Col style={{ maxWidth: '500px' }} $width={isMobile ? "100%" : "60%"} $border={`1px solid${Colors.fieldBorder}`} $borderRadius={10} $backgroundColor={Colors.whiteBackground} $gap={10} $padding="20px">
      <Title $fontSize={24}>{translate('login')}</Title>
      <TabButtons>

        <TabButtonsItem $isActive={activeTab === "1"} onClick={() => setActiveTab("1")}>
          <Link
            className="nav-link active"
            to="#"
          >
            {translate('login_with_password')}
          </Link>
        </TabButtonsItem>

        <TabButtonsItem $isActive={activeTab === "2"} onClick={() => setActiveTab("2")}>
          <Link
            className="nav-link"
            to="#"

          >
            {translate('login_with_otp')}
          </Link>
        </TabButtonsItem>
      </TabButtons>
      <FormComponent
        fields={activeTab === "1" ? passwordLoginFields : otpLoginFields}

        onChange={handleInputChange}
        serverRes={combineServerRes}
      />
      <p>
      {translate('forgot_password')}{" "}
      <TextLink route={routesMap.forgotPassword.to}>{translate('reset_password')}</TextLink>
      </p>
      <ActionButton onClick={() => { activeTab === "1"?processLogin():processOTPLogin(formValues.emailOrPhone) }} width="100%" route="#" label={translate('login')} />

      <VerticalSepWithTitle title={translate('or')} />
      <SocialAuthComponent setFormValues={setFormData} />
      <div className="contact-signup">
        <p>
          {translate('dont_have_account')}{" "}
          <TextLink onClick={() => { setForm("registration") }}>{translate('register')}</TextLink>
        </p>
      </div>

    </Col>

  )

};